import { Link } from 'react-router-dom';
import type { Movie } from '@/types/content';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: '2 / 3' }}>
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.type} ${movie.year}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-semibold text-accent-300 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400" />
          {movie.rating.toFixed(1)}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 text-sm font-black text-background-950">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 left-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {movie.type}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.genres.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}